import { useState, useEffect } from 'react'
import { FiMapPin } from 'react-icons/fi'
import http from 'http'

const Color = () => {
  const [ color, setColor ] = useState()

  useEffect( () => {
    if ( color ) return

    http( {
      method: 'GET',
      url: '/me'
    } )
      .then( ( { data } ) => {
        setColor( data.color )
      } )
  }, [] )

  const handleColorChange = ( e ) => {
    const { value } = e.target

    http( {
      method: 'PUT',
      url: '/me/color',
      data: { value }
    } )
      .then( ( { data } ) => {
        setColor( value )
      } )
  }

  return <div className="vs space-between gap-2x in-air-2x">
    <div className="vs gap-2x size-3x5">
      <span>
        <FiMapPin />
      </span>

      <span>color</span>
    </div>

    <input
      name="color"
      type="color"
      value={ color }
      onChange={ handleColorChange }
    />

  </div>
}

export default Color
